import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Input,
  Button,
  Form,
  FormGroup,
  Label,
  Alert,
  Card,
  CardBody,
} from "reactstrap";
import axios from "axios";
import constants from "../../Constants";
import { isValidPhoneNumber } from "libphonenumber-js";
import FeatherIcon from "feather-icons-react";

const Section = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    mobile: "",
    consent_share: false,
    consent_call: false,
  });
  const [params, setParams] = useState({});

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const vehicleid = searchParams.get("vehicleid");
    const driverid = searchParams.get("driverid");
    const tags = searchParams.get("tags");

    setParams({ vehicleid, driverid, tags });
  }, []);

  const isValidSAMobile = (mobile) => {
    return isValidPhoneNumber(mobile, "ZA");
  };

  const handleChange = (e) => {
    let value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    if (e.target.name === "mobile") {
      // Allow only numbers and + symbol
      value = value.replace(/[^0-9+]/g, "");
    }

    setFormData({ ...formData, [e.target.name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!params.vehicleid || !params.driverid) {
      setError("Invalid link parameters.");
      setLoading(false);
      return;
    }

    if (!formData.mobile) {
      setError("Please enter your mobile number.");
      setLoading(false);
      return;
    }

    if (!isValidSAMobile(formData.mobile)) {
      setError(
        "Please enter a valid South African mobile number (e.g. 082 123 4567)"
      );
      setLoading(false);
      return;
    }

    if (!formData.consent_share && !formData.consent_call) {
      setError("Please select at least one consent option.");
      setLoading(false);
      return;
    }

    try {
      await axios.post(`${constants.baseURL}/tracker-partnership-consent`, {
        vehicleid: params.vehicleid,
        driverid: params.driverid,
        mobile: formData.mobile,
        consent_share: formData.consent_share,
        consent_call: formData.consent_call,
        tags: params.tags,
      });
      setSuccess(true);
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8} lg={6}>
              <Card className="border-0 shadow-sm">
                <CardBody className="p-5">
                  <div className="mb-4">
                    <div className="d-flex justify-content-center align-items-center gap-3 mb-3">
                      <img
                        src="tracker-logo.png"
                        alt="Tracker"
                        height="50"
                        style={{ objectFit: "contain" }}
                      />
                      <span className="text-muted h5 mb-0">×</span>
                      <span className="h4 fw-bold mb-0 text-dark">QikTruck</span>
                    </div>
                  </div>
                  <div className="mb-4 text-success">
                    <FeatherIcon icon="check-circle" size="64" />
                  </div>
                  <h3 className="mb-3 fw-bold">Thank You!</h3>
                  <p className="text-muted mb-0 lead">
                    Your request has been received. A Tracker representative will
                    be in touch shortly to discuss your installation and benefits.
                  </p>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div
      className="py-5 min-vh-100"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <Container>
        <Row className="justify-content-center mb-5">
          <Col md={10} lg={8} className="text-center">
            <div className="d-flex justify-content-center align-items-center gap-3 mb-4">
              <img
                src="tracker-logo.png"
                alt="Tracker"
                height="60"
                style={{ objectFit: "contain" }}
              />
              <div className="border-start mx-3" style={{ height: "40px" }}></div>
              <div className="text-start">
                <small className="text-uppercase text-muted d-block fw-bold" style={{ fontSize: "0.7rem", letterSpacing: "1px" }}>
                  In Partnership with
                </small>
                <span className="h5 fw-bold mb-0 text-dark">QikTruck</span>
              </div>
            </div>

            <h1 className="display-5 fw-bold mb-3">2 Months Free Vehicle Tracking</h1>
            <p className="lead text-muted">
              Exclusive offer for QikTruck drivers. Activate your device for safer trips and better control.
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col md={10} lg={6}>
            <Card className="border-0 shadow-lg overflow-hidden">
              <div className="bg-dark text-white p-4 text-center">
                <h4 className="mb-0 fw-normal">Request Your Call Back</h4>
              </div>
              <CardBody className="p-4 p-md-5">
            

                <div className="mb-5">
                  <div className="d-flex align-items-start mb-3">
                    <div className="bg-light rounded-circle p-2 mr-3 text-primary d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                      <span className="fw-bold">1</span>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1">Confirm Details</h6>
                      <p className="text-muted small mb-0">Verify your mobile number and provide consent.</p>
                    </div>
                  </div>
                   <div className="d-flex align-items-start mb-3">
                    <div className="bg-light rounded-circle p-2 mr-3 text-primary d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                      <span className="fw-bold">2</span>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1">Installation</h6>
                      <p className="text-muted small mb-0">Tracker calls you to complete your setup.</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-start">
                    <div className="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                      <FeatherIcon icon="check" size="20" />
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1 text-success">Enjoy 2 Months Free even if you are already a Tracker customer</h6>
                      <p className="text-muted small mb-0">Get this special offer even if you are already a Tracker customer.</p>
                    </div>
                  </div>
                </div>

                <Form onSubmit={handleSubmit}>
                  <FormGroup className="mb-4">
                    <Label for="mobile" className="fw-bold text-dark">
                      Mobile Number
                    </Label>
                    <Input
                      type="tel"
                      name="mobile"
                      id="mobile"
                      placeholder="e.g. 082 123 4567"
                      value={formData.mobile}
                      onChange={handleChange}
                      className="form-control-lg bg-light border-0"
                      required
                    />
                    <small className="text-muted mt-2 d-block">
                      <FeatherIcon icon="info" size="12" className="mr-1" />
                      Use your WhatsApp or QikTruck number.
                    </small>
                  </FormGroup>

                  <div className="mb-3">
                    <Label className="fw-bold text-dark mb-3">Consent</Label>
                    <div className="p-3 bg-light rounded-3 mb-3">
                      <FormGroup check className="mb-0">
                        <Label check className="d-flex align-items-start">
                          <Input
                            type="checkbox"
                            name="consent_share"
                            checked={formData.consent_share}
                            onChange={handleChange}
                            className="mt-1 mr-2"
                          />
                          <div>
                            <span className="fw-bold text-dark d-block mb-1">
                              Share details with Tracker
                            </span>
                            <small className="text-muted lh-sm d-block">
                              I allow QikTruck to share my details with Tracker to explain their services and arrange installation.
                            </small>
                          </div>
                        </Label>
                      </FormGroup>
                    </div>

                    <div className="p-3 bg-light rounded-3 mb-4">
                      <FormGroup check className="mb-0">
                        <Label check className="d-flex align-items-start">
                          <Input
                            type="checkbox"
                            name="consent_call"
                            checked={formData.consent_call}
                            onChange={handleChange}
                            className="mt-1 mr-2"
                          />
                          <div>
                            <span className="fw-bold text-dark d-block mb-1">
                              Consent to be contacted
                            </span>
                            <small className="text-muted lh-sm d-block">
                              Tracker may contact me via phone/WhatsApp to discuss the 2 months free offer.
                            </small>
                          </div>
                        </Label>
                      </FormGroup>
                    </div>
                  </div>
                  {error && (
                  <Alert color="danger" className="mb-4 rounded-3">
                    <div className="d-flex align-items-center">
                      <FeatherIcon icon="alert-circle" size="20" className="mr-2" />
                      <span>{error}</span>
                    </div>
                  </Alert>
                )}
                  <Button
                    color="warning"
                    size="lg"
                    block
                    disabled={
                      loading ||
                      !formData.mobile ||
                      (!formData.consent_share && !formData.consent_call)
                    }
                    className="fw-bold text-dark py-3 shadow-sm w-100"
                  >
                    {loading ? "Submitting Request..." : "Claim 2 Months Free"}
                  </Button>
                  
                  <div className="text-center mt-3">
                    <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                      By submitting, you confirm you are the authorized user of the vehicle. <br/>
                      T&Cs apply.
                    </small>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Section;